export const filtersCountUpdater = <
  T extends {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    children?: any[] | null;
    count: number;
    code: string;
    title: string;
  },
>(
  currentItems: T[],
  newItems: T[],
): T[] => {
  function buildCodeMap(items: T[], map = new Map<string, T>()): Map<string, T> {
    items.forEach((item) => {
      map.set(item.code, item);
      if (item.children && item.children.length > 0) {
        buildCodeMap(item.children, map);
      }
    });
    return map;
  }

  const newItemsMap = buildCodeMap(newItems);

  const updateItems = (items: T[]): T[] => {
    return items.map((item) => {
      const newItem = newItemsMap.get(item.code);
      const updatedChildren =
        item.children && item.children.length > 0 ? updateItems(item.children) : undefined;

      return {
        ...item,
        count: newItem ? newItem.count : 0,
        children: updatedChildren,
      };
    });
  };

  return updateItems(currentItems);
};
